import { z } from "zod";
import {
  hasSearchFilters,
  readSearchState,
  writeSearchState,
} from "./searchState";
import { type AcquiredListView, type AcquiredPropertySearch } from "../types";

export const ACQUIRED_SEARCH_SESSION_KEY = "acquireBookList.searchState";
const schema = z.object({
  userId: z.string(),
  isSharable: z.boolean(),
  query: z.string(),
});

/** 同じ利用者・共有設定の検索だけを復元し、PDFのURLや検索結果は保存しない。 */
export const loadStoredSearchState = (
  userId: string,
  isSharable: boolean
): string | undefined => {
  try {
    const raw = sessionStorage.getItem(ACQUIRED_SEARCH_SESSION_KEY);
    if (!raw) return undefined;
    const saved = schema.safeParse(JSON.parse(raw));
    if (
      !saved.success ||
      saved.data.userId !== userId ||
      saved.data.isSharable !== isSharable
    )
      return undefined;
    const params = new URLSearchParams(saved.data.query);
    const search = readSearchState(params, isSharable);
    if (!hasSearchFilters(search)) return undefined;
    return writeSearchState(
      search,
      params.get("view") === "properties" ? "properties" : "requests"
    ).toString();
  } catch {
    // ブラウザで保存が制限されていても検索は続行する。
    return undefined;
  }
};

export const saveStoredSearchState = (
  search: AcquiredPropertySearch,
  view: AcquiredListView,
  userId: string,
  isSharable: boolean
): void => {
  try {
    if (!hasSearchFilters(search)) {
      sessionStorage.removeItem(ACQUIRED_SEARCH_SESSION_KEY);
      return;
    }
    sessionStorage.setItem(
      ACQUIRED_SEARCH_SESSION_KEY,
      JSON.stringify({
        userId,
        isSharable,
        query: writeSearchState({ ...search, page: 0 }, view).toString(),
      })
    );
  } catch {
    // 保存できない場合もURLによる検索・履歴操作は継続する。
  }
};
